import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../../utils/axios';
import { errorToast } from '../../../utils/toasts/toasts';

const initialState = {
    cities: [],
    states: [],
    countries: [],
    allCities: [],
    allStates: [],
    error: null
};

const citiesSlice = createSlice({
    name: 'cities',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllCities.pending, (state) => {
                state.cities = [];
            })
            .addCase(getAllCities.fulfilled, (state, action) => {
                const cityData = action.payload?.data || [];
                const city163 = cityData.find((city) => city.id === 163);
                state.cities = city163 ? [city163] : [];
                state.allCities = cityData;
                // console.log("Cities fetched successfully, filtered for id 163:", action.payload);
            })
            .addCase(getAllCities.rejected, (state, action) => {
                state.error = action.payload;
                console.error('Failed to fetch cities -> ', action.payload);
            });

        builder
            .addCase(getAllStates.pending, (state) => {
                state.states = [];
            })
            .addCase(getAllStates.fulfilled, (state, action) => {
                const stateData = action.payload?.data || [];
                const state4030 = stateData.find((state) => state.id === 4030);
                state.states = state4030 ? [state4030] : [];
                state.allStates = stateData;
                // console.log("States fetched successfully, filtered for id 4030:", action.payload);
            })
            .addCase(getAllStates.rejected, (state, action) => {
                state.error = action.payload;
                console.error('Failed to fetch states -> ', action.payload);
            });

        builder
            .addCase(getAllCountries.pending, (state) => {
                state.countries = [];
            })
            .addCase(getAllCountries.fulfilled, (state, action) => {
                const countryData = action.payload?.data || [];
                // const country101 = countryData.find((country) => country.id === 101);
                // state.countries = country101 ? [country101] : [];
                state.countries = countryData;
                // console.log("Countries fetched successfully:", action.payload);
            })
            .addCase(getAllCountries.rejected, (state, action) => {
                state.error = action.payload;
                console.error('Failed to fetch countries -> ', action.payload);
            });
    }
});

// export const { } = citiesSlice.actions;

export default citiesSlice.reducer;

export const getAllCities = createAsyncThunk(
    'cities/getAllCities',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/cities`);
            return response.data;
        } catch (error) {
            // errorToast(error?.message || 'Failed to fetch cities');
            return rejectWithValue(error.response.data);
        }
    }
);

export const getAllStates = createAsyncThunk(
    'cities/getAllStates',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/states`);
            return response.data;
        } catch (error) {
            errorToast(error?.message || 'Failed to fetch states');
            return rejectWithValue(error.response.data);
        }
    }
);

export const getAllCountries = createAsyncThunk(
    'cities/getAllCountries',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/countries`);
            return response.data;
        } catch (error) {
            errorToast(error?.message || 'Failed to fetch countries');
            return rejectWithValue(error.response.data);
        }
    }
);
